//TODO DON`T TOUCH!!!! При переезеде на NextJS. переписать
export const cabinetHandleRefresh = () => {
  // Navigate to the same route to force a re-render
  window.location.reload();
};
